<template>
  <a-row style="margin-bottom: 10px" class='upload-class'>
    <a-col>
      <div style="margin-bottom: 10px">
        <a-row>
          <a-col :md="24" :sm="24">
            <a-col :span="3" v-if="options.title&&options.title.length>0" class="ant-form-item-label">
              <label>{{options.title}}</label>
            </a-col>
            <a-col :span="options.title&&options.title.length>0?21:24">
              <a-upload v-if="!disableSubmit" ref="aupload" :before-upload="beforeUpload"
                        :action="uploadAction" @change="handleFileUpload" :fileList="myfileList"
                        :multiple="true" :accept="accept" :headers="headers">
                <a-button>
                  <a-icon type="upload" :disabled="disableSubmit" />
                  {{options.btnText}}
                </a-button>
              </a-upload>
            </a-col>
          </a-col>

        </a-row>
      </div>
      <template v-if='accept.indexOf("png")==-1 && accept.indexOf("jpg")==-1 && accept.indexOf("svg")==-1 && accept.indexOf("jpeg")==-1'>
        <a-table v-if='isDrag && disableSubmit' :columns="columns" :dataSource="datasource" :pagination="false"
                 @dragenter="handlePicDragEnter" @dragover="handlePicDragOver" @drop="handlePicDropInvalid" bordered>
          <template slot="fileName" slot-scope="text,record,index">
            <a @click="() => openPDF(record)">{{record.fileName}}</a>
          </template>
          <template slot="fileSize" slot-scope="text, record, index">
            {{(record.fileSize)/1024 | numFilter}}KB
          </template>
          <template slot="operation3" slot-scope="text,record,index">
            <div class='editable-row-operations' v-if="!disableSubmit">
              <a-popconfirm title='是否确认删除?' @confirm="() => delTable(record.key)">
                <a>删除</a>
              </a-popconfirm>
            </div>
            <div class='editable-row-operations' v-if="disableSubmit">
              <a v-if="download" @click="downUploadFile(record.id)">下载</a>
              <a v-if="!download" @click="openPDF(record)">浏览</a>
            </div>
          </template>
        </a-table>
        <a-table v-else :columns="columns" :dataSource="datasource" :pagination="false"
                 @dragenter="handlePicDragEnter" @dragover="handlePicDragOver" @drop="handlePicDropInvalid" bordered>
          <template slot="fileName" slot-scope="text,record,index">
            <a @click="() => openPDF(record)">{{record.fileName}}</a>
          </template>
          <template slot="fileSize" slot-scope="text, record, index">
            {{(record.fileSize)/1024 | numFilter}}KB
          </template>
          <template slot="operation3" slot-scope="text,record,index">
            <div class='editable-row-operations' v-if="!disableSubmit">
              <a-popconfirm title='是否确认删除?' @confirm="() => delTable(record.key)">
                <a>删除</a>
              </a-popconfirm>
            </div>
            <div class='editable-row-operations' v-if="disableSubmit">
              <a v-if="download" @click="downUploadFile(record.id)">下载</a>
              <a v-if="!download" @click="openPDF(record)">浏览</a>
            </div>
          </template>
        </a-table>
      </template>

      <div v-else style='display: flex' :style="[{flexWrap:isLineBreak?'wrap':''}]">
        <div style='margin-right:10px;border: 1px solid #CCCCCC;width: 100px;height: 100px;position: relative;' :style="[{marginTop:isLineBreak?'5px':''}]" v-for='(item,index) in datasource' :key='index' @click='openPDF(item)'>
          <img style='width: 100%;height: 100%'  :src="baseUrl + '/sys/common/file/thumbnail/100/100/' + item.id"  />
          <i v-if='!disableSubmit' @click.stop='delTable(item.key)' class='el-icon-error' style='position:absolute;top: -10px;right: -10px;font-size: 25px;background-color: #ffffff;border-radius: 50%'></i>
        </div>
      </div>
    </a-col>
    <div v-if='isDrag' class="dragbox-wrap" @drop="handlePicSubmit" v-show="onPicDrag">
      <a-icon class="iws-upload" type="upload" />
      <p class="iws-upload">释放文档即可上传</p>
    </div>
    <div v-if='isDrag' class="dragbox-wrap" v-show="uploading">
      <a-spin class="iws-upload" size="large" tip="文件上传中..." />
    </div>
    <PDFModal ref="pdfview"></PDFModal>
    <VideoModel ref="videoview"></VideoModel>
  </a-row>
</template>

<script>
  import {
    queryFileList
  } from '@/api/api'
  import Vue from 'vue'
  import {
    ACCESS_TOKEN
  } from '../../store/mutation-types'
  import PDFModal from '@comp/PDFView/PDFModal'
  import {
    postAction
  } from '@/api/manage'
  import VideoModel from '../VideoMode/VideoModel'

  export default {
    name: 'IwsUpload',
    props: {
      isDrag: {
        type: Boolean,
        default: true
      },
      filesrc: {
        type: String,
        required: true,
        default: ''
      },
      srcid: {
        type: Number,
        required: true,
        default: 0
      },
      disableSubmit: {
        type: Boolean,
        required: false,
        default: false
      },
      options: {
        type: Object,
        required: false,
        default: function() {
          return {
            btnText: '选择文件',
            title: ''
          }
        }
      },
      emptyState: {
        type: Boolean,
        required: false,
        default: false
      },
      accept: {
        type: String,
        required: false,
        default: ''
      },
      download: {
        type: Boolean,
        required: false,
        default: true
      },
	  isLineBreak:{
		type:Boolean,
		default:false
	  }
    },
    data() {
      return {
        baseUrl:window._CONFIG['domianURL'],
        columns: [{
          title: '文件名称',
          dataIndex: 'fileName',
          align: 'center',
          width: '20%',
          scopedSlots: {
            customRender: 'fileName'
          }
        }, {
          title: '文件大小',
          dataIndex: 'fileSize',
          align: 'center',
          width: '10%',
          scopedSlots: {
            customRender: 'fileSize'
          }
        }, {
          title: '上传人',
          align: 'center',
          dataIndex: 'createBy_userName',
          width: '10%',
          scopedSlots: {
            customRender: 'createBy_userName'
          }
        }, {
          title: '上传时间',
          align: 'center',
          dataIndex: 'createTime',
          width: '20%',
          scopedSlots: {
            customRender: 'createTime'
          }
        }, {
          title: '操作',
          width: '10%',
          align: 'center',
          dataIndex: 'operation3',
          scopedSlots: {
            customRender: 'operation3'
          }
        }],
        datasource: [],
        uploadFileList: [],
        myfileList: [],
        draggerfileList: [],
        fileDelList: [],
        fileUploadUrl: window._CONFIG['domianURL'] + '/sys/common/file/upload', //使用专门的接口上传文件
        headers: {}, //设置上传的请求头部，IE10 以上有效
        onPicDrag: false,
        uploading: false
      }
    },
    components: {
      VideoModel,
      PDFModal
    },
    created() {
      const token = Vue.ls.get(ACCESS_TOKEN)
      this.headers = {
        'X-Access-Token': token
      }
      this.loadUploadFiles()
    },
    watch: {
      download: {
        handler(val) {
          if(val){
            this.columns=[{
              title: '文件名称',
              dataIndex: 'fileName',
              align: 'center',
              width: '20%',
              scopedSlots: {
                customRender: 'fileName'
              }
            }, {
              title: '文件大小',
              dataIndex: 'fileSize',
              align: 'center',
              width: '10%',
              scopedSlots: {
                customRender: 'fileSize'
              }
            }, {
              title: '上传人',
              align: 'center',
              dataIndex: 'createBy_userName',
              width: '10%',
              scopedSlots: {
                customRender: 'createBy_userName'
              }
            }, {
              title: '上传时间',
              align: 'center',
              dataIndex: 'createTime',
              width: '20%',
              scopedSlots: {
                customRender: 'createTime'
              }
            }, {
              title: '操作',
              width: '10%',
              align: 'center',
              dataIndex: 'operation3',
              scopedSlots: {
                customRender: 'operation3'
              }
            }]
          }else{
            this.columns=[{
              title: '文件名称',
              dataIndex: 'fileName',
              align: 'center',
              width: '20%',
              scopedSlots: {
                customRender: 'fileName'
              }
            }, {
              title: '文件大小',
              dataIndex: 'fileSize',
              align: 'center',
              width: '10%',
              scopedSlots: {
                customRender: 'fileSize'
              }
            }, {
              title: '上传人',
              align: 'center',
              dataIndex: 'createBy_userName',
              width: '10%',
              scopedSlots: {
                customRender: 'createBy_userName'
              }
            }, {
              title: '上传时间',
              align: 'center',
              dataIndex: 'createTime',
              width: '20%',
              scopedSlots: {
                customRender: 'createTime'
              }
            }]
          }

        },
        immediate: true,
      },
      srcid: function(val) {
        this.loadUploadFiles()
      },
      filesrc: function(val) {
        this.loadUploadFiles()
      },
      emptyState: {
        handler(val) {
          console.log('emptyState', this.emptyState)
          if (val) {
            this.fileDelList = []
            this.datasource = []
            this.uploadFileList = []
          }
        },
        immediate: true,
        deep: true

      }
    },
    mounted() {
      // this.uploadFiles = apiUrl.uploadFiles;
      // 监听拖拽leave事件
      document.addEventListener('dragleave', this.handlePicDragLeave)
      document.addEventListener('drop', this.handlePicDropInvalid, false)
      document.addEventListener('dragover', this.handlePicDragOver, false)
    },
    destroyed() {
      // 组件销毁前移除该事件
      document.removeEventListener('dragleave', this.handlePicDragLeave)
      document.removeEventListener('drop', this.handlePicDropInvalid)
      document.removeEventListener('dragover', this.handlePicDragOver)
    },
    computed: {
      /**
       * 上传的地址
       */
      uploadAction: function() {
        return this.fileUploadUrl
      }
    },
    methods: {
      test() {
        this.loadUploadFiles()
      },
      //监听事件
      handlePicDragLeave(e) {
        e.preventDefault()
        e.stopPropagation()
        if (+e.offsetX <= 0 && +e.offsetY <= 0) {
          this.onPicDrag = false
        } else {
          this.onPicDrag = true
        }
      },
      //拖拽事件
      handlePicDragEnter(e) {
        this.onPicDrag = true
        e.preventDefault()
        e.stopPropagation()
      },
      handlePicDragOver(e) {
        this.onPicDrag = true
        e.preventDefault()
        e.stopPropagation()
      },
      handlePicDropInvalid(e) {
        this.onPicDrag = false
        e.preventDefault()
        e.stopPropagation()
      },
      handlePicSubmit(e) {
        this.onPicDrag = false
        e.preventDefault()
        e.stopPropagation()
        let files = e.dataTransfer.files
        let len = files.length //获取文件个数
        // 只允许上传一个文件
        if (len > 1) {
          this.$message_custom('请选择单文件上传','error')
          return
        }
        let file = files[0]
        if (!file) {
          this.$message_custom('请上传文件','warning')
          return
        }
        //检测文件类型
        let checkfile = this.beforeUpload(file)
        if (!checkfile) {
          return
        }
        //提交文件
        const formData = new FormData()
        formData.append('file', file)
        let that = this
        postAction(this.fileUploadUrl, formData).then((res) => {
          if (res.success && res.result) {
            that.uploading = false
            file.originFileObj = file
            //文件进度
            file.percent = 100
            //上传文件响应数据
            file.response = res
            //文件上传状态
            file.status = 'done'
            //自定义uid防止报错
            file.uid = 'iwsload'
            that.draggerfileList.push(file)
            res.result.createTime = '未提交'
            //定义filesrc值防止报错
            res.result.key = res.result.id
            res.result.fileSrc = this.filesrc
            that.datasource.push(res.result)
            this.uploadFileList.push({
              id: res.result.id
            })
            this.$emit('change', this.getUploadListToFromData({}))
            this.$emit('input', this.getUploadListToFromData({}))
          } else {
            that.uploading = false
            this.$message_custom('文件上传失败,请重试!','error')
          }
        }).catch(function(error) {
          that.uploading = false
          this.$message_custom('请检查文件类型或者文件大小是否超过限制','error')
        })
      },
      openPDF(item) {
        /*if (item&&item.fileName&&/\.(mp4)$/i.test(item.fileName)){
          this.$refs.videoview.show(item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id)
        }else{
          this.$refs.pdfview.showPDF(item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id)
        }*/
        //使用文件在线预览
        //this.$refs.pdfview.showPDF(item.fileName, 'http://127.0.0.1/iws/sys/common/file/view/' + item.id, 'online')
        this.$refs.pdfview.showPDF(item.id+'-'+item.fileName, window._CONFIG['domianURL'] + '/sys/common/file/view/' + item.id,
          'online')
      },
      /* 文件下载 */
      downUploadFile(text) {
        if (!text) {
          this.$message_custom('未知的文件','warning')
          return
        }
        window.open(window._CONFIG['domianURL'] + '/sys/common/file/download/' + text)
      },
      // 主要成分表格相关的操作函数
      handleFileUpload(info) {
        if (info.file.status === 'done') {
          this.uploading = false
          var response = info.file.response
          if (!response.success) {
            this.$message_custom('文件上传失败,请重试!','error')
          } else {
            info.file.response.result.fileSrc = this.filesrc
            this.uploadFileList.push({
              id: info.file.response.result.id
            })
            info.file.response.result.key = info.file.response.result.id
            info.file.response.result.createTime = '未提交'
            this.datasource.push(info.file.response.result)
            info.fileList = info.fileList.filter(t => t.uid != info.file.uid)
            this.$emit('change', this.getUploadListToFromData({}))
            this.$emit('input', this.getUploadListToFromData({}))
          }
        }
        if (info.file.status === 'error') {
          this.uploading = false
          this.$message_custom('文件上传失败,无服务未响应!','error')
          info.fileList = info.fileList.filter(t => t.uid != info.file.uid)
        }
        if (info.fileList.length > 0) {
          var templist = []
          info.fileList.forEach(file => {
            if (file.status)
              templist.push(file)
          })
          info.fileList = templist
        }
        this.myfileList = info.fileList
      },
      beforeUpload(file, fileList) {
        var flag = false
        var msg = ''
        if (this.accept && this.accept.length > 0) {
          let acceptlist = this.accept.split(',')
          if (acceptlist.length > 0) {
            acceptlist.forEach(item => {
              item = item.replace('.', '')
              msg += msg.length > 0 ? ('、' + item) : item
              let patt = new RegExp('.(' + item + ')$', 'i')
              if (patt.test(file.name))
                flag = true
            })
          }
        } else {
          flag = true
        }
        if (flag) {
          this.uploading = true
        } else {
          this.$message_custom('请选择' + msg + '文件上传!','error')
        }
        return flag
      },
      resetUploadFiles() {
        this.uploadFileList = []
        this.myfileList = []
        this.fileDelList = []
        this.draggerfileList = []
        this.datasource = []
      },
      loadUploadFiles(filesrc1, srcid1) {
        let that = this
        var filesrc = '',
          srcid = ''
        if (filesrc1 && srcid1) {
          filesrc = filesrc1
          srcid = srcid1
        } else {
          filesrc = that.filesrc
          srcid = that.srcid
        }
        this.uploadFileList = []
        this.myfileList = []
        this.fileDelList = []
        this.draggerfileList = []
        this.datasource = []

        if (filesrc && srcid) {
          queryFileList(filesrc, srcid).then((res) => {
            console.log(res)
            if (res.success) {
              let docsList = []
              for (let i = 0; i < res.result.length; i++) {
                let doc = res.result[i]
                doc.key = doc.id
                docsList.push(doc)
              }
              that.datasource = docsList
              this.$forceUpdate()
            }
          })
        } else {
          that.datasource = []
        }
        that.$emit('uploadFileList',that.datasource)
      },
      delTable(key) {
        const newData = this.datasource.filter(item => key != item.key)
        const docItem = this.datasource.find(item => key == item.key)
        const uploadData = this.uploadFileList.filter(item => key != item.id)
        this.fileDelList.push(docItem)
        this.datasource = newData
        this.uploadFileList = uploadData
        this.fileDelList.forEach(file => {
          if (file.createTime == '未提交') file.createTime = null
        })
        this.$emit('change', this.getUploadListToFromData({}))
        this.$emit('input', this.getUploadListToFromData({}))
      },
      getUploadListToFromData(formData) {
        formData.fileDelList = this.fileDelList
        formData.sysFileList = this.uploadFileList
        return formData
      },
      getUploadList() {
        return {
          fileDelList: this.fileDelList,
          sysFileList: this.uploadFileList
        }
      }
    },
    filters: {
      numFilter(value) {
        let realVal = ''
        if (!isNaN(value) && value !== '') {
          // 截取当前数据到小数点后两位
          realVal = parseFloat(value).toFixed(2)
        } else {
          realVal = '--'
        }
        return realVal
      }
    }
  }
</script>
<style>
  .ant-popover.ant-popover-placement-top {
    z-index: 100000 !important;
  }
</style>
<style scoped>
  .dragbox-wrap {
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    opacity: 0.8;
    z-index: 99;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    user-select: none;
  }

  p {
    font-size: 34px;
  }


  .iws-upload {
    position: absolute;
    bottom: 30%;
    left: 50%;
    transform: translate(-50%, -50%);

  }
</style>
